<template>
  <div class="bot-msg msg-wrapper" v-if="!(msg.slug==='typing')">
    <div class="msg-content">
      <!-- {{msg.message}} -->
      <!-- component is -->
      <component v-if="msg.slug" :is="getFileName(msg.slug)" :con="msg"></component>
      <component v-else-if="msg.channelData" :is="getFileName(msg.channelData.slug)" :con="msg.channelData"></component>

    </div>

  </div>
</template>
<script>
import textData from "./messagesType/textData";
import messageData from "./messagesType/messageData";
import imageData from "./messagesType/imageData";
import heroData from "./messagesType/heroData";
import triviaQuestionData from "./messagesType/triviaQuestionData";
import galleryData from "./messagesType/galleryData";
import videoData from "./messagesType/videoData";
import audioData from "./messagesType/audioData";
import flightStatusData from "./messagesType/flightStautsData";
import flightPassngersData from "./messagesType/travelData";
import adaptiveCard from "./messagesType/adaptiveCard";
import gifData from "./messagesType/gifData";
import cardDateTimeInputData from "./messagesType/cardDateTimeInputData";
import weatherData from "./messagesType/weatherData";
import receiptData from "./messagesType/receiptData";
import mapData from "./messagesType/mapData";
import userInputData from "./messagesType/userInputData";
import multiInputData from "./messagesType/multiInputData"
import attachmentData from "./messagesType/attachment";
import orderData from "./messagesType/orderCard"
export default {
  components: {
    textData,
    messageData,
    imageData,
    heroData,
    triviaQuestionData,
    galleryData,
    videoData,
    audioData,
    adaptiveCard,
    gifData,
    flightStatusData,
    flightPassngersData,
    cardDateTimeInputData,
    weatherData,
    receiptData,
    mapData,
    userInputData,
    multiInputData,
    attachmentData,
    orderData
  },
  props: ["msg"],
  data() {
    return {
      test: "test",
      slugs: [
        "text",
        'message',
        "image",
        "hero",
        "gallery",
        // "typing",
        "video",
        "audio",
        "gif",
        "trivia-question",
        "flight-status",
        "flight-passngers",
        "card-date-time-input",
        "weather",
        "receipt",
        "map",
        "user-input",
        "multi-input",
        'attachment',
        'order'
      ],
      textSlugs: ['prompt-input','prompt-date','prompt-multi-input'],
      adaptiveCards: ["receipt", "weather"]
    };
  },
  computed: {},
  created() {
    if (this.msg.sender.sender_type === 'USER') {
      this.msg.type = 'user'
    } else {
      this.msg.type = 'bot'
    }
  },
  mounted() {
    if (this.msg.sender.sender_type === 'USER') {
      this.msg.type = 'user'
    } else {
      this.msg.type = 'bot'
    }
  },
  methods: {
    getFileName(slug) {
      if (this.slugs.includes(slug)) {
        return slug + "-data";
      } else if (slug === 'image_attachment') {
        return "image-data"
      }
        else if (this.textSlugs.includes(slug)) {
        return 'text-data'
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.msg-wrapper {

}
.msg-owner {

}
</style>
